module.exports = __webpack_public_path__ + "static/media/baccarat.a03ce186.JPG";